import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { App, Button, DatePicker, Flex, Input, Radio, Select, Skeleton, Space } from "antd"
import { useContext, useEffect, useState } from "react"
import { useTheme } from "styled-components"
import { ShowMessagePage } from "../config"
import { createPromotion, getProducts, getPromotions, updatePromotion } from "../endpoints"
import { DetailedPromotionInterface, PriceInterface, ProductPromotionInterface, PromotionInterface } from "../types"

import { EditOutlined } from "@ant-design/icons"
import Table, { ColumnsType } from "antd/es/table"
import dayjs from "dayjs"
import { ContainerFull, LabeledBox, Padded, RowInput } from "../components/GeneralComponents"
import { UserContext } from "../context"

const dateFormat = "YYYY-MM-DD"
// value={dayjs('2015-06-06', dateFormat)}

interface EditPromotionProductProps {
    productDetail: ProductPromotionInterface
    index: number
    detailsArray: ProductPromotionInterface[]
    productsOptions?: { id: number; name: string; price: PriceInterface[] }[]
    setDetailsArray: React.Dispatch<React.SetStateAction<ProductPromotionInterface[]>>
}

const EditPromotionProduct = (props: EditPromotionProductProps) => {
    let detailsArray2 = [...props.detailsArray]
    // consolelog("props.productDetail.productid", props.productDetail.productid)
    //   console.log("EditPromotionProduct props", props)
    const theme = useTheme()

    return (
        <div key={props.index}>
            <LabeledBox title={""} border style={{ width: "40em" }}>
                <Flex vertical gap="large">
                    <div>
                        <Select
                            style={{ width: "20em" }}
                            placeholder="Select a product"
                            // style={{  height: "3em" }}
                            value={props.productDetail.productid}
                            onChange={(value) => {
                                detailsArray2[props.index].productid = value
                                if (value === -1) {
                                    detailsArray2 = [detailsArray2[props.index]]
                                }
                                props.setDetailsArray(detailsArray2)
                            }}
                            optionFilterProp="label"
                            showSearch
                            options={props.productsOptions?.map((s) => {
                                return { value: s.id, label: s.name }
                            })}
                            size="middle"
                        />
                        {props.productDetail.productid !== -1 && (
                            <div style={{ color: theme.secondary }}>
                                Current price for{" "}
                                {props.productsOptions?.find((x) => x.id === props.productDetail.productid)?.name} is{" "}
                                {props.productsOptions
                                    ?.find((x) => x.id === props.productDetail.productid)
                                    ?.price?.map((x) => x.price + " " + x.unit + " in " + x.country)
                                    .join(",") ?? ""}{" "}
                            </div>
                        )}
                    </div>

                    <div>
                        <Radio.Group
                            onChange={(e) => {
                                // console.log(e.target.value)
                                detailsArray2[props.index].promotionType = e.target.value

                                props.setDetailsArray(detailsArray2)
                            }}
                            value={props.productDetail.promotionType ?? "low value"}
                        >
                            <Radio value={"percent off"}>Percent Off</Radio>
                            <Radio value={"low price"}>Low Price</Radio>
                        </Radio.Group>
                    </div>
                    {props.productDetail.promotionType === "low price" && (
                        <Space>
                            <Input
                                style={{ color: "black", width: "10em" }}
                                addonBefore="Price:"
                                id="price"
                                type="number"
                                value={props.productDetail.price?.find((x) => x.country === "USA")?.price ?? ""}
                                onChange={(e) => {
                                    // Initialize price array if it doesn't exist
                                    if (!detailsArray2[props.index].price) {
                                        detailsArray2[props.index].price =
                                            props.productsOptions?.find((x) => x.id === props.productDetail.productid)
                                                ?.price ?? []
                                    }
                                    
                                    // Ensure price array exists
                                    if (!detailsArray2[props.index].price) {
                                        detailsArray2[props.index].price = []
                                    }
                                    
                                    const priceArray = detailsArray2[props.index].price!
                                    
                                    // Find USA price entry index
                                    const idx = priceArray.findIndex((x) => x.country === "USA")
                                    
                                    const inputValue = e.target.value === "" ? 0 : Number(e.target.value)
                                    
                                    if (idx !== -1) {
                                        // Update existing USA price
                                        priceArray[idx].price = inputValue
                                    } else {
                                        // Create new USA price entry
                                        priceArray.push({
                                            country: "USA",
                                            price: inputValue,
                                            unit: "USD"
                                        })
                                    }
                                    
                                    props.setDetailsArray([...detailsArray2])
                                }}
                                size="middle"
                                name="price"
                            />
                            <span>
                                Currency:{" "}
                                <Select
                                    style={{ width: "6em" }}
                                    onChange={(value) => {
                                        // console.log(value)

                                        const idx = detailsArray2[props.index].price?.findIndex(
                                            (x) => x.country === "USA"
                                        ) as number //need to make sure USA price is there
                                        if (idx !== undefined && idx !== null && idx !== -1) {
                                            detailsArray2[props.index].price![idx].unit = value
                                            props.setDetailsArray(detailsArray2)
                                        }
                                    }}
                                    optionFilterProp="label"
                                    showSearch
                                    defaultValue={"USD"}
                                    options={[{ value: "USD", label: "USD" }]}
                                    size="middle"
                                />
                            </span>
                            <span>
                                Country:{" "}
                                <Select
                                    style={{ width: "6em" }}
                                    onChange={(value) => {
                                        console.log(value)

                                        const idx = detailsArray2[props.index].price?.findIndex(
                                            (x) => x.country === "USA"
                                        ) as number //need to make sure USA price is there
                                        if (idx && idx !== null) {
                                            detailsArray2[props.index].price![idx].country = value
                                            props.setDetailsArray(detailsArray2)
                                        }
                                    }}
                                    optionFilterProp="label"
                                    showSearch
                                    defaultValue={"USA"}
                                    options={[{ value: "USA", label: "USA" }]}
                                    size="middle"
                                />
                            </span>
                        </Space>
                    )}
                    {props.productDetail.promotionType === "percent off" && (
                        <Space>
                            <div>
                                <RowInput
                                    style={{ color: "black", width: "20em" }}
                                    addonBefore={
                                        props.productDetail.productid === -1
                                            ? "Percent off for all products:"
                                            : "Percent off"
                                    }
                                    id="percentOff"
                                    type="number"
                                    value={props.productDetail.percentOff ?? 0}
                                    onChange={(e) => {
                                        // console.log(e.target.value)
                                        detailsArray2[props.index].percentOff = Number(e.target.value)
                                        props.setDetailsArray(detailsArray2)
                                    }}
                                    size="middle"
                                    name="percentOff"
                                />
                            </div>
                        </Space>
                    )}
                    
                   
                
                </Flex>
            </LabeledBox>
        </div>
    )
}

export const Promotions = (): JSX.Element => {
    const { modal } = App.useApp()
    const user = useContext(UserContext)
    const queryClient = useQueryClient()

    const theme = useTheme()
    const [selectedRow, setSelectedRow] = useState<number>(-1)

    const [editorMode, setEditorMode] = useState<string>("none")

    const [promotionId, setPromotionId] = useState<number | null>(null)
    const [code, setCode] = useState<string | null>()
    const [promotionDetails, setPromotionDetails] = useState<ProductPromotionInterface[]>([])
    const [allowedUses, setAllowedUses] = useState<number | null>(null)
    const [forInstitution, setForInstitution] = useState<string | null>(null)
    const [forUser, setForUser] = useState<number | null>(null)
    const [daysToExpire, setDaysToExpire] = useState<number | null>()
    const [dateToExpire, setDateToExpire] = useState<string | null>(null)
    const [notes, setNotes] = useState<string | null>(null)
    const [maxOrders, setMaxOrders] = useState<number | null>(null)
    const [maxSamples, setMaxSamples] = useState<number | null>(null)
    // eslint-disable-next-line
    const [ts, setTs] = useState<string | null>(null)

    const [productsOptions, setProductsOptions] = useState<{ id: number; name: string; price: PriceInterface[] }[]>()
    const { isPending, isError, data, error } = useQuery({
        queryKey: ["getproducts"],
        queryFn: getProducts,
    })
    function setPromotionForEdit(i: number) {
        const currentPromotion = promotionsData?.promotions[i]
        // consolelog('promotionsData?.promotions',promotionsData?.promotions)
        if (currentPromotion) {
            // console.log('setting prom for edit')
            setPromotionId(currentPromotion.id)
            setCode(currentPromotion.code)
            setPromotionDetails(currentPromotion.details)
            setAllowedUses(currentPromotion.alloweduses)
            setForInstitution(currentPromotion.forinstitution)
            setForUser(currentPromotion.foruser)
            setDateToExpire(currentPromotion.expiration)
            setDaysToExpire(Math.ceil(dayjs(currentPromotion.expiration, dateFormat).diff(dayjs(), "days")))
            setNotes(currentPromotion.notes)
            setTs(currentPromotion.ts ?? "")
            setMaxOrders(currentPromotion.maxOrders ?? -1)
            setMaxSamples(currentPromotion.maxSamples ?? -1)
            setEditorMode("edit")
        }
    }
    useEffect(() => {
        if (data?.code === 1000) {
            // consolelog("data.products", data.products)
            const productsInDb = data.products
                .filter((x) => x.active)
                .map((x) => {
                    return { id: x.id, name: x.name, price: x.price }
                })
            setProductsOptions([
                { id: -1, name: "All products", price: [{ unit: "USD", price: 15, country: "USA" }] },
                ...productsInDb,
            ])
        }
    }, [data])

    const {
        isPending: isPendingPr,
        isError: isErrorPr,
        data: promotionsData,
        error: errorPr,
    } = useQuery({
        queryKey: ["getpromotions"],
        queryFn: getPromotions,
    })
    const addMutation = useMutation({
        mutationFn: createPromotion,
        onSuccess: (data) => {
            // Invalidate and refetch
            queryClient.invalidateQueries({ queryKey: ["getpromotions"] })
            // console.log(data)
            if (data.code !== 1000)
                modal.warning({
                    content: "Failed to create promotion. " + data.message,
                })
            else setEditorMode("none")
        },
        onError: (error) => {
            modal.error({ content: error.message })
        },
    })

    const updateMutation = useMutation({
        mutationFn: updatePromotion,
        onSuccess: (data) => {
            // Invalidate and refetch
            queryClient.invalidateQueries({ queryKey: ["getpromotions"] })
            // console.log(data)
            if (data.code !== 1000) modal.warning({ content: "failed to update promotion" })
            else setEditorMode("none")
        },
        onError: (error) => {
            modal.error({ content: error.message })
        },
    })

    if (isPending || isPendingPr) {
        return <Skeleton />
    }

    if (isError || isErrorPr) {
        return ShowMessagePage("Error", error?.message ?? "unknown error" + errorPr?.message ?? "")
    }
    if (promotionsData?.code !== 1000) {
        return <div>error in getting promotion data</div>
    }

    const columns: ColumnsType<DetailedPromotionInterface> = [
        {
            title: "Edit",
            dataIndex: "id",
            render: (value, record, index) => {
                return (
                    <EditOutlined
                        style={{ color: "blue" }}
                        onClick={async () => {
                            // consolelog("index clicked:", index)
                            setPromotionForEdit(index)
                        }}
                    />
                )
            },
        },
        {
            title: "ID",
            dataIndex: "id",
            render: (text, record, index) => {
                return <span>{record.id}</span>
            },
        },
        {
            title: "Code",
            dataIndex: "code",
            render: (text, record, index) => {
                return <span>{record.code}</span>
            },
        },
        {
            title: "Details",
            dataIndex: "details",
            render: (text, record, index) => {
                return <span>{JSON.stringify(record.details)}</span>
            },
        },
        {
            title: "maxSamples",
            dataIndex: "maxSamples",
            render: (text, record, index) => {
                return <span>{record.maxSamples}</span>
            },
        },
        {
            title: "maxOrders",
            dataIndex: "maxOrders", 
            render: (text, record, index) => {
                return <span>{record.maxOrders}</span>
            },
        },
        {
            title: "For Lab or Company",
            dataIndex: "forinstitution",
            render: (text, record, index) => {
                return <span>{record.forinstitution}</span>
            },
        },
        {
            title: "For User",
            dataIndex: "foruser",
            render: (text, record, index) => {
                return <span>{record.forUserName}</span>
            },
        },
        {
            title: "Expiration",
            dataIndex: "expiration",
            render: (text, record, index) => {
                 return <span>{record.expiration ? new Date(record.expiration).toLocaleString() : ""}</span>
            },
        },
        {
            title: "Allowed Uses",
            dataIndex: "alloweduses",
            render: (text, record, index) => {
                return <span>{record.alloweduses}</span>
            },
        },
        {
            title: "Creator",
            dataIndex: "creator",
            render: (text, record, index) => {
                return <span>{record.creator}</span>
            },
        },
        {
            title: "Notes",
            dataIndex: "notes",
            render: (text, record, index) => {
                return <span>{record.notes}</span>
            },
        },
        {
            title: "ts",
            dataIndex: "ts",
            render: (text, record, index) => {
                return <span>{record.ts ? new Date(record.ts).toLocaleString() : ""}</span>
            },
        },
    ]
    // consolelog('promotionsData',promotionsData)

    return (
        <ContainerFull style={{ fontFamily: '"Rubik", sans-serif' }}>
            <h2>Promotions</h2>
            <Table
                dataSource={promotionsData.promotions?.map((row) => {
                    return { ...row, key: row.id }
                })}
                rowClassName={(record, index) =>
                    index === selectedRow ? "highlighted-table-row" : "regular-table-row"
                }
                columns={columns}
                pagination={{ position: ["bottomLeft"], pageSize: 15 }}
                size="middle"
                onRow={(record, index) => {
                    return {
                        onClick: () => {
                            if (index === selectedRow) {
                                setSelectedRow(-1)
                            } else {
                                setSelectedRow(index ?? -1)
                            }
                        },
                    }
                }}
            />
            <Button
                size="large"
                type="primary"
                style={{
                    fontSize: "1rem",
                    // fontWeight: "bold",
                    width: "16em",
                    color: theme.primary,
                    backgroundColor: theme.white,
                    boxShadow: "1px 1px 2px 2px rgba(0, 0, 0, 0.5)",
                }}
                icon={
                    <span
                        className="material-symbols-outlined"
                        style={{
                            verticalAlign: "middle",
                            fontSize: "1rem",
                            color: theme.secondary,
                        }}
                    >
                        add
                    </span>
                }
                onClick={() => {
                    setPromotionId(null)
                    setCode(null)
                    setPromotionDetails([])
                    setAllowedUses(null)
                    setForInstitution(null)
                    setForUser(null)
                    setDateToExpire(null)
                    setDaysToExpire(null)
                    setNotes(null)
                    setMaxOrders(-1)
                    setMaxSamples(-1)

                    setEditorMode("new")
                }}
            >
                Add a promotion
            </Button>
            {editorMode !== "none" && (
                <LabeledBox title="Enter Promotion Information" border>
                    <Flex vertical gap={20}>
                        <Padded style={{ marginBottom: "-1em" }}>Promotion ID: {promotionId}</Padded>
                        <RowInput
                            style={{ color: "black", maxWidth: "26em" }}
                            addonBefore="Promotion Code:"
                            id="code"
                            value={code ?? ""}
                            onChange={(e) => {
                                // console.log(e.target.value)
                                setCode(e.target.value)
                            }}
                            size="middle"
                            name="code"
                        />
                        {promotionDetails.map((productDetail, index, detailsArray) => {
                            return (
                                <EditPromotionProduct
                                    key={index}
                                    productDetail={productDetail}
                                    index={index}
                                    detailsArray={detailsArray}
                                    setDetailsArray={setPromotionDetails}
                                    productsOptions={productsOptions}
                                ></EditPromotionProduct>
                            )
                        })}
                        <Button
                            size="large"
                            type="primary"
                            style={{
                                fontSize: "1rem",
                                // fontWeight: "bold",
                                width: "16em",
                                color: theme.primary,
                                backgroundColor: theme.white,
                                boxShadow: "1px 1px 2px 2px rgba(0, 0, 0, 0.5)",
                            }}
                            icon={
                                <span
                                    className="material-symbols-outlined"
                                    style={{
                                        verticalAlign: "middle",
                                        fontSize: "1rem",
                                        color: theme.secondary,
                                    }}
                                >
                                    add
                                </span>
                            }
                            onClick={() => {
                                setPromotionDetails([
                                    ...promotionDetails,
                                    {
                                        productid: 2,
                                        promotionType: "percent off",
                                        percentOff: 0,
                                        price: null,
                                        
                                        
                                    },
                                ])
                            }}
                        >
                            Add a product for promotion
                        </Button>
                        <Space>
                            <RowInput
                                style={{ color: "black", width: "14em" }}
                                addonBefore="Allowed uses:"
                                id="allowedUses"
                                type="number"
                                value={allowedUses ?? -1}
                                onChange={(e) => {
                                    console.log(e.target.value)
                                    setAllowedUses(Number(e.target.value ?? ""))
                                }}
                                size="middle"
                                name="allowedUses"
                            />{" "}
                            <span style={{ color: theme.secondary }}> -1 means no checking against uses</span>
                        </Space>
                        <div>
                            <Space size={"middle"}>
                                <span>
                                    Days to expire:{" "}
                                    <RowInput
                                        style={{ color: "black", width: "14em" }}
                                        id="daysToExpire"
                                        type="number"
                                        value={daysToExpire ?? 0}
                                        onChange={(e) => {
                                            // console.log(e.target.value)
                                            // setDaysToExpire(Math.ceil(date.diff(dayjs(),'day',true)))
                                            const n = Number(e.target.value ?? "")
                                            setDaysToExpire(n)
                                            setDateToExpire(
                                                dayjs(dayjs(), dateFormat).add(n, "days").format(dateFormat)
                                            )
                                        }}
                                        size="middle"
                                        name="daysToExpire"
                                    />
                                </span>
                                <span>
                                    Or date to expire:{" "}
                                    <DatePicker
                                        style={{ color: "black", width: "14em" }}
                                        id="dateToExpire"
                                        // value={daysToExpire ?? 0}
                                        value={dayjs(dateToExpire ?? dayjs(), dateFormat)}
                                        onChange={(date, dateString) => {
                                            console.log(date)
                                            console.log(dateString)
                                            setDateToExpire(date.format(dateFormat))
                                            setDaysToExpire(Math.ceil(date.diff(dayjs(), "day", true)))
                                        }}
                                        size="middle"
                                        name="dateToExpire"
                                    />
                                </span>
                            </Space>
                            <div style={{ color: theme.secondary }}>Expiration date is always checked</div>
                        </div>
                        <Space>
                            <RowInput
                                style={{ color: "black", width: "25em" }}
                                addonBefore="For Lab or Company:"
                                id="forinstitution"
                                value={forInstitution ?? ""}
                                onChange={(e) => {
                                    console.log(e.target.value)
                                    setForInstitution(e.target.value ?? "")
                                }}
                                size="middle"
                                name="forinstitution"
                            />{" "}
                            <span style={{ color: theme.secondary }}> empty means no checking against institution</span>
                        </Space>
                        <Space>
                            <RowInput
                                style={{ color: "black", width: "14em" }}
                                addonBefore="For User:"
                                id="forUser"
                                type="number"
                                value={forUser ?? -1}
                                onChange={(e) => {
                                    console.log(e.target.value)
                                    setForUser(Number(e.target.value) ?? -1)
                                }}
                                size="middle"
                                name="forUser"
                            />{" "}
                            <span style={{ color: theme.secondary }}> -1 means no checking against user</span>
                        </Space>
                         
                    <div>
                        <RowInput
                            style={{ color: "black", width: "20em" }}
                            addonBefore={
                                     "For number of samples"
                            }
                            id="maxSamples"
                            type="number"
                            value={maxSamples??0 }
                            onChange={(e) => {
                                // console.log(e.target.value)
                               setMaxSamples(Number(e.target.value) ?? 0)
                            }}
                            size="middle"
                            name="maxSamples"
                        />
                        <div style={{ color: theme.secondary, fontSize: "0.9em", marginTop: "0.25em" }}>
                            -1 means unlimited samples
                        </div>
                    </div>
                     <div>
                        <RowInput
                            style={{ color: "black", width: "20em" }}
                            addonBefore={
                                     "For number of orders"
                            }
                            id="maxOrders"
                            type="number"
                            value={maxOrders ?? 0}
                            onChange={(e) => {
                                // console.log(e.target.value)
                                setMaxOrders(Number(e.target.value) ?? 0)
                            }}
                            size="middle"
                            name="maxOrders"
                        />
                        <div style={{ color: theme.secondary, fontSize: "0.9em", marginTop: "0.25em" }}>
                            -1 means unlimited orders
                        </div>
                    </div>
                
                        <div>
                            <RowInput
                                style={{ color: "black" }}
                                addonBefore="Notes:"
                                id="notes"
                                value={notes ?? ""}
                                onChange={(e) => {
                                    // console.log(e.target.value)
                                    setNotes(e.target.value ?? "")
                                }}
                                size="middle"
                                name="notes"
                            />
                        </div>
                        <Flex justify="center" gap="large">
                            <Button
                                size="large"
                                style={{
                                    fontSize: "1rem",
                                    // fontWeight: "bold",

                                    boxShadow: "1px 1px 2px 2px rgba(0, 0, 0, 0.5)",
                                }}
                                onClick={async () => {
                                    setEditorMode("none")
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                size="large"
                                type="primary"
                                style={{
                                    fontSize: "1rem",
                                    // fontWeight: "bold",
                                    backgroundColor: theme.primary,
                                    boxShadow: "1px 1px 2px 2px rgba(0, 0, 0, 0.5)",
                                }}
                                icon={
                                    <span
                                        className="material-symbols-outlined"
                                        style={{
                                            verticalAlign: "middle",
                                            fontSize: "1rem",
                                            color: "white",
                                        }}
                                    >
                                        file_save
                                    </span>
                                }
                                onClick={async () => {
                                    if (!promotionDetails || promotionDetails.length === 0) {
                                        modal.warning({ content: "Please add at least one product for promotion" })
                                        return
                                    }

                                    // Remove duplicates based on productid and promotionType
                                    const uniquePromotionDetails = promotionDetails.filter((detail, index, self) => 
                                        index === self.findIndex((d) => 
                                            d.productid === detail.productid && d.promotionType === detail.promotionType
                                        )
                                    )
                                    
                                    const promotion: PromotionInterface = {
                                        id: promotionId ?? undefined,
                                        code: code ?? "",
                                        details: uniquePromotionDetails,
                                        forinstitution: forInstitution,
                                        foruser: forUser,
                                        expiration: dateToExpire ?? dayjs().format(dateFormat),
                                        alloweduses: allowedUses ?? -1,
                                        creator: user.user?.firstName + " " + user.user?.lastName,
                                        notes: notes ?? "",
                                        maxOrders: maxOrders ?? -1,
                                        maxSamples: maxSamples ?? -1,
                                        
                                    }
                                    if (!promotion.code) {
                                        modal.warning({ content: "code cannot be empty" })
                                    } else if (!daysToExpire || (daysToExpire < 0 && !promotionId)) {
                                        modal.warning({
                                            content: "days to expire cannot be negative for new promotion",
                                        })
                                    } else if (promotion.id) {
                                        updateMutation.mutate({
                                            promotion,
                                        })
                                    } else {
                                        addMutation.mutate({
                                            promotion,
                                        })
                                    }
                                }}
                            >
                                Save
                            </Button>
                        </Flex>
                    </Flex>
                </LabeledBox>
            )}
        </ContainerFull>
    )
}
